<app-side-bar></app-side-bar>
<app-settings-modal></app-settings-modal>
<app-nav-bar></app-nav-bar>

<div class="container">
  <div class="container-bulk-sale">
    <h1 class="title">{{ 'IMPORT_SALES' | translate}}</h1>
    <div class="form-card">
      <div class="header">
        <!-- <h5 class="modal-title">Creación masiva de Órdenes</h5> -->
      </div>
      <div class="modal-body">

        <div class="mb-3">
          <p>{{"BEFORE_UPLOADING_TEMPLATE" | translate}}.</p>
          <button class="btn btn-disable me-2" (click)="downloadTemplate()">
            <i class="bi bi-download"></i> {{"DOWNLOAD_TEMPLATE" | translate}}
          </button>
        </div>

        <!-- Carga de Archivo -->
        <div class="mb-3">
          <label class="form-label">{{"UPLOAD_TEMPLATE" | translate}}:</label>
          <input type="file" class="form-control" accept=".xlsx, .xls" (change)="onFileSelected($event)">
        </div>

        <!-- Loading Preview -->
        <div *ngIf="isLoadingPreview" class="text-center my-4">
          <div class="spinner-border text-primary" role="status"></div>
          <p class="mt-2">{{"VALIDATING_DATA" | translate}}...</p>
        </div>

        <!-- Vista Previa y Resultados -->
        <div *ngIf="!isLoadingPreview && file">
          <div class="alert alert-info d-flex justify-content-between align-items-center">
            <span>
              <strong>{{"TOTAL_IN_EXCEL" | translate}}:</strong> {{ validOrders.length + errorReportData.length }} | 
              <strong>{{"VALID" | translate}}:</strong> {{ validOrders.length }} | 
              <strong>{{"WITH_ERRORS" | translate}}:</strong> {{ errorReportData.length }}
            </span>
            <button class="btn btn-sm btn-danger" *ngIf="errorReportData.length > 0" (click)="downloadErrorReport()">
              {{"DOWNLOAD_ERROR_REPORT" | translate}}
            </button>
          </div>

          <!-- Tabla de Clientes Válidos -->
          <div *ngIf="validOrders.length > 0" class="table-responsive" style="max-height: 300px; overflow-y: auto;">
            <table class="table table-sm table-striped">
              <thead class="table-light sticky-top">
                <tr>
                  <th>{{"FIRST_NAME" | translate}}</th>
                  <th>{{"LAST_NAME" | translate}}</th>
                  <th>{{"NATIONAL_ID" | translate}}</th>
                  <th>{{"PRODUCT" | translate}}</th>
                  <th>{{"VARIANT" | translate}}</th>
                  <th>{{"DATE" | translate}}</th>
                  <th>{{"PAYMENT_METHOD" | translate}}</th>
                  <th>{{"ORDER_STATUS" | translate}}</th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let order of validOrders">
                  <td>{{ order.client.firstName }}</td>
                  <td>{{ order.client.lastName }}</td>
                  <td>{{ order.client.nationalId }}</td>
                  <td>{{ order.item.productName }}</td>
                  <td>{{ order.item.variantValueName || 'N/A' }}</td>
                  <td>{{ order.date }}</td>
                  <td>{{ getPaymentTypeName(order.orderData.payment_method) }}</td>
                  <td>{{ getSaleStateName((order.orderData.status)) }}</td>
                </tr>
              </tbody>
            </table>
          </div>

          <div *ngIf="validOrders.length === 0 && errorReportData.length > 0" class="alert alert-warning">
            {{"NO_VALID_ORDERS" | translate}}
          </div>
        </div>

      </div>
      <!-- Barra de Progreso Estimada (Solo visible durante el procesamiento) -->
      <div *ngIf="isProcessing" class="mt-4 p-3 bg-light rounded border">
        <div class="d-flex justify-content-between align-items-center mb-2">
          <span class="fw-semibold text-primary">
            <i class="bi bi-hourglass-split me-1"></i>
            {{"PROCESSING_IN_BACKGROUND" | translate}}...
          </span>
          <span class="badge bg-primary">{{ progress | number:'1.0-0' }}%</span>
        </div>
        
        <div class="progress" style="height: 24px;">
          <div 
            class="progress-bar progress-bar-striped progress-bar-animated bg-success" 
            role="progressbar" 
            [style.width.%]="progress"
            [attr.aria-valuenow]="progress" 
            aria-valuemin="0" 
            aria-valuemax="100">
            <span *ngIf="progress > 15" class="fw-bold text-white">
              {{ progress < 99 ? ('PROCESSING' | translate) + '...' : ('FINALIZING' | translate) + '...' }}
            </span>
          </div>
        </div>
        
        <p class="text-muted small mt-2 mb-0 text-center">
          {{"PROCESSING_ORDERS" | translate}}({{ validOrders.length }}).
        </p>
      </div>

      <!-- Botón de acción (Deshabilitado mientras procesa) -->
      <div class="footer">
        <!-- Crear un warning text -->
        <div *ngIf="errorReportData.length > 0" class="alert alert-warning">
          {{"ERRORS_IN_ORDERS_MESSAGE" | translate}}
        </div>
        <div *ngIf="processError" class="alert alert-danger">
          {{ processError.label | translate }}
        </div>
        <div *ngIf="validationError" class="alert alert-danger">
          {{ validationError.label | translate }}
        </div>
        <button type="button" class="btn btn-success" [disabled]="validOrders.length === 0 || isProcessing || errorReportData.length > 0" [hidden]="validOrders.length === 0 || errorReportData.length > 0 || isProcessing" (click)="processBulk()">
          <span *ngIf="isProcessing" class="spinner-border spinner-border-sm me-1"></span>
          {{ isProcessing ? ('STARTING' | translate) : ('PROCESS_ORDERS' | translate) }}
        </button>
      </div>
    </div>
  </div>
</div>

